import { ModifiedIndexBleedingModelResponse } from '@/pages/ScreeningPage/screeningController'
import { ScreeningModel } from '@/pages/ScreeningPage/screeningModel'

export type ModifiedBleedingNumbers = '16' | '21' | '24' | '44' | '41' | '36'
type Zones = 'up' | 'left' | 'right' | 'down'

export type ModifiedBleedingValues = {
  up: boolean
  down: boolean
  left: boolean
  right: boolean
}

export class ModifiedIndexBleedingModel extends ScreeningModel {
  public readonly values: ModifiedBleedingValues

  constructor(cell: ModifiedIndexBleedingModelResponse) {
    super(cell.id)
    this.values = cell.values
  }

  public getCellForSend(): ModifiedIndexBleedingModelResponse {
    return {
      values: this.values,
      id: this.id,
    }
  }

  public switchStatusValue(zone: Zones): void {
    this.values[zone] = !this.values[zone]
  }
}
